import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '@/views/login'
import register from '@/views/register'
import HomePage from "@/views/HomePage";
import PJGLHomepage from "@/views/PJGL/PJGLHomepage";
import AduitAward_Manager from "@/views/PJGL/AduitAward_Manager";
import AduitAward_Company from "@/views/PJGL/AduitAward_Company";
import PrimaryInfo_01 from "@/views/PJGL/ProjectSequence/PrimaryInfo_01";
import ProjectAbstract_02 from "@/views/PJGL/ProjectSequence/ProjectAbstract_02";
import PrimaryScienceInnovate_03 from "@/views/PJGL/ProjectSequence/PrimaryScienceInnovate_03";
import ProjectInfluence_05 from "@/views/PJGL/ProjectSequence/ProjectInfluence_05";
import AcquiredAward_06 from "@/views/PJGL/ProjectSequence/AcquiredAward_06";
import Thesis_08 from "@/views/PJGL/ProjectSequence/Thesis_08";
import CompletePerson_09 from "@/views/PJGL/ProjectSequence/CompletePerson_09";
import CompleteCompany_10 from "@/views/PJGL/ProjectSequence/CompleteCompany_10";
import RecommendOpinions_11 from "@/views/PJGL/ProjectSequence/RecommendOpinions_11";
import ThirdPartyEvaluation_04 from "@/views/PJGL/ProjectSequence/ThirdPartyEvaluation_04";
import IntellectualProperty_07 from "@/views/PJGL/ProjectSequence/IntellectualProperty_07";
import attachment_12 from "@/views/PJGL/ProjectSequence/attachment_12";
import projectHomePage from "../views/PJGL/ProjectSequence/projectHomePage";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/register',
    name: 'register',
    component: register
  },
  {
    path: '/HomePage',
    name: 'HomePage',
    component: HomePage,
    children: [{
      path: 'PJGLHomepage',
      name: 'PJGLHomepage',
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      },
      component: PJGLHomepage,
      children: [{
        path: 'AduitAward_Manager',
        name: 'AduitAward_Manager',
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
        component: AduitAward_Manager,
      }, {
        path: 'AduitAward_Company',
        name: 'AduitAward_Company',
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
        component: AduitAward_Company,
      }, {
        path: 'projectHomePage',
        name: 'projectHomePage',
        meta: {
          requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
        },
        component: projectHomePage,
        children: [{
          path: 'PrimaryInfo_01',
          name: 'PrimaryInfo_01',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: PrimaryInfo_01,
        }, {
          path: 'ProjectAbstract_02',
          name: 'ProjectAbstract_02',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: ProjectAbstract_02,
        }, {
          path: 'PrimaryScienceInnovate_03',
          name: 'PrimaryScienceInnovate_03',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: PrimaryScienceInnovate_03,
        }, {
          path: 'ThirdPartyEvaluation_04',
          name: 'ThirdPartyEvaluation_04',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: ThirdPartyEvaluation_04,
        }, {
          path: 'ProjectInfluence_05',
          name: 'ProjectInfluence_05',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: ProjectInfluence_05,
        }, {
          path: 'AcquiredAward_06',
          name: 'AcquiredAward_06',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: AcquiredAward_06,
        }, {
          path: 'IntellectualProperty_07',
          name: 'IntellectualProperty_07',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: IntellectualProperty_07,
        }, {
          path: 'Thesis_08',
          name: 'Thesis_08',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: Thesis_08,
        }, {
          path: 'CompletePerson_09',
          name: 'CompletePerson_09',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: CompletePerson_09,
        }, {
          path: 'CompleteCompany_10',
          name: 'CompleteCompany_10',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: CompleteCompany_10,
        }, {
          path: 'RecommendOpinions_11',
          name: 'RecommendOpinions_11',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: RecommendOpinions_11,
        }, {
          path: 'attachment_12',
          name: 'attachment_12',
          meta: {
            requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
          },
          component: attachment_12,
        }]
      },]
    }]
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js